// extracted by mini-css-extract-plugin
module.exports = {"bar":"SlideShow_bar__3I1Lm","details":"SlideShow_details__3xJpj","names":"SlideShow_names__2Z8A5","controls":"SlideShow_controls__IIgzL"};